import React from 'react';
import PropTypes from 'prop-types';
import Container from './Container';

const RightSidebar = ({ componentProps }) => {
  return (
    <Container componentProps={componentProps} />
  );
};

RightSidebar.defaultProps = {
  componentProps: {},
};

RightSidebar.propTypes = {
  componentProps: PropTypes.object,
};

export default RightSidebar;
